/**
 * Extract project ID from any project-related route
 * Matches: /projects/:id, /projects/:id/execute, /projects/:id/specs, etc.
 * 
 * @example
 * getProjectIdFromPath('/projects/abc') // 'abc'
 * getProjectIdFromPath('/projects/abc/execute') // 'abc'
 * getProjectIdFromPath('/projects/abc/specs?tab=1') // 'abc'
 * getProjectIdFromPath('/projects') // undefined
 * getProjectIdFromPath('/admin') // undefined
 */
export const getProjectIdFromPath = (path: string): string | undefined => {
  const match = path.match(/^\/projects\/([^/]+)(?:\/|$)/);
  return match?.[1];
};
